import { Grid,  useMediaQuery, useTheme } from "@mui/material";

function SideImage() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  // const matchDownMD = useMediaQuery(
  //   "only screen and (min-width : 769px) and (max-width : 992px)"
  // );
  const smallHeight = useMediaQuery("(max-height : 900px)");

  return (
    <>
      {!matchDownSM || !smallHeight ? (
        <Grid
          item
          xs={false}
          sm={false}
          md={5}
          lg={5}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <img
          alt={'login'}
            // aspectRatio: "16/16",
            src={"/assets/images/auth-side.png"}
            height={"65%"}
            width={"65%"}
            style={{
              backgroundRepeat: "no-repeat",
              // backgroundColor: (t:any) =>
              //   t.palette.mode === "light"
              //     ? t.palette.grey[50]
              //     : t.palette.grey[900],
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        </Grid>
      ) : null}
    </>
  );
}

export default SideImage;
